export type otpState = {
  phoneNumber?: string;
  step: "verify" | "send";
  timer: number;
};

export type OtpAction =
  | {
      type: "SET_PHONE_NUMBER";
      payload: string;
    }
  | { type: "SET_STEP"; payload: "verify" | "send" }
  | { type: "SET_TIMER"; payload: number }
  | { type: "RESET" };

const otpReducer = (state: otpState, action: OtpAction): otpState => {
  switch (action.type) {
    case "SET_PHONE_NUMBER":
      return {
        ...state,
        phoneNumber: action.payload,
        step: "verify",
        timer: 120,
      };
    case "SET_STEP":
      return { ...state, step: action.payload };
    case "SET_TIMER":
      return { ...state, timer: action.payload };
    case "RESET":
      return { phoneNumber: undefined, step: "send", timer: 0 };
    default:
      return state;
  }
};

export default otpReducer;
